import {
  HttpErrorResponse,
  HttpEventType,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';

import { catchError, EMPTY, filter, map, tap } from 'rxjs';

import { CustomHttpHeaders } from '@core/configurations/custom-http-headers.config';

import {
  BackendError,
  BackendResponse,
  ResponseService,
} from '@core/services/response.service';

export const ResponseInterceptor: HttpInterceptorFn = (
  httpRequest,
  httpHandler,
) => {
  const responseService = inject(ResponseService);

  responseService.setIsToastHeaders(
    httpRequest.headers.get(CustomHttpHeaders.ShowResponseToast),
  );

  return httpHandler(httpRequest).pipe(
    filter(
      (
        event,
      ): event is HttpResponse<BackendResponse<Record<string, unknown>>> =>
        event instanceof HttpResponse,
    ),
    tap((response: HttpResponse<BackendResponse<Record<string, unknown>>>) => {
      responseService.setResponseBodySignal(response.body);
      responseService.showPasswordExpirationToast();
    }),
    map((response: HttpResponse<BackendResponse<Record<string, unknown>>>) => {
      const { body } = response;
      const event = response;

      if (
        body &&
        'data' in body &&
        response.type === HttpEventType.Response &&
        body.message !== null
      ) {
        responseService.setStatus(event.status);
        responseService.setHttpRequest(httpRequest);
        responseService.showGenericSuccessToast(body.status, body.message);

        return event.clone({
          body: body.data,
        });
      }

      return event;
    }),
    catchError((error: HttpErrorResponse) => {
      const backendError = error.error as BackendError;

      responseService.showErrorToast(
        error.status,
        backendError?.message || 'Error desconegut',
      );

      return EMPTY;
    }),
  );
};
